<template>
  <div class="update-notice">
    <div class="title">
      <span>{{ $attrs['extra-params']['title'] }}：</span>
    </div>
    <div class="AmEditor">
      <AmEditor v-model="noticeContent" :editorHeight="300"></AmEditor>
    </div>
    <div class="bottom">
      <el-button size="mini" @click="handleClose">取消关闭</el-button>
      <el-button size="mini" type="primary" @click="updateWriteNotice" :loading="loading">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import AmEditor from '../../../../../elements/editor/AmEditor'
export default {
  name: 'UpdateNotice',
  props: ['visible'],
  components: {AmEditor},
  data () {
    return {
      enrollBatchId: '',
      noticeContent: '',
      loading: false
    }
  },
  created () {
    this.enrollBatchId = this.$attrs['cell-value']
    this.queryWriteNotice()
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.queryWriteNotice()
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('hidePopover')
    },
    queryWriteNotice () {
      this.$ajax({
        url: this.$attrs['extra-params']['queryUrl'],
        method: 'post',
        data: this.$qs.stringify({
          enrollBatchId: this.enrollBatchId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.noticeContent = response.data['noticeContent']
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      })
    },
    updateWriteNotice () {
      this.loading = true
      this.$ajax({
        url: this.$attrs['extra-params']['updateUrl'],
        method: 'post',
        data: this.$qs.stringify({
          enrollBatchId: this.enrollBatchId,
          noticeContent: this.noticeContent
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(`${this.$attrs['extra-params']['title']}保存成功`)
              this.handleClose()
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .update-notice{
    padding: 10px;
    .AmEditor{
      margin-top: 5px;
    }
    .bottom{
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
</style>
